// extracted by mini-css-extract-plugin
module.exports = {"burger":"burger_burger__zxSN7","open":"burger_open__pmzBF"};